/**
 * Created by PanJiaChen on 16/11/18.
 */


export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function isEmailNull (rule, value, callback) {
  if (rule.required) {
    if (!value) {
      callback(new Error('请输入邮箱'));
    } else {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!reg.test(value)) { 
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    }
  } else {
    callback();
  }
}

export function isPhoneNull (rule, value, callback) {
  if (rule.required) {
    if (!value) {
      callback(new Error('请输入联系方式'));
    } else {
      const phoneRegex = /^1[34578]\d{9}$|^0\d{2,3}-\d*$/;
      if (!phoneRegex.test(value)) { 
        callback(new Error('请输入正确的联系号码'));
      } else {
        callback();
      }
    }
  } else {
    callback();
  }
}

/* 手机号码校验 */
export function isPhone (rule, value, callback) {
  if (rule.required) {
    if (!value) {
      callback(new Error('联系号码不能为空'));
    }
  }
  if (value) {
    var phone = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
    var tel = /\d{3}-\d{8}|\d{4}-\d{7}/;
    if (phone.test(value) || tel.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的电话号码'));
    }
    // } else {
    //     callback(new Error('请输入联系方式'))
    // }
  } else {
    callback();
  }
}

/* 金额校验 */
export function checkMoney (num = 2) {
  return function (rule, value, callback) {
    if (rule.required) {
      if (!value && value !== 0) {
        callback(new Error(`金额不能为空`));
      }
    }
    if (value) {
      //   var number = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
      var number = new RegExp("^(([1-9]\\d*)|0)(\\.\\d{1," + num + "})?$");
      if (!number.test(value)) {
        callback(new Error(`请输入正确格式的金额`));
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
}